import { Link } from "react-router-dom";

export const APP_VERSION = "v1.3.0";

// Single-color RESADA logo (map-pin + radar glyph on transparent bg) + wordmark.
export default function Logo({ dark = false, to = "/", iconSize = 36, showVersion = false, className = "" }) {
  const inner = (
    <>
      <img src="/logo.png" alt="RESADA" style={{ width: iconSize, height: iconSize }} className="object-contain shrink-0" />
      <span className="flex flex-col leading-none">
        <span className={`font-display font-extrabold text-lg ${dark ? "text-white" : "text-slate-900"}`}>RESADA</span>
        {showVersion && <span className="text-[10px] font-medium tracking-wide mt-0.5 text-slate-400">{APP_VERSION}</span>}
      </span>
    </>
  );
  if (!to) return <span className={`inline-flex items-center gap-2 ${className}`}>{inner}</span>;
  return <Link to={to} className={`inline-flex items-center gap-2 ${className}`}>{inner}</Link>;
}
